/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Event_When_OneInputs */

const en_features_event_when_one = /** @type {(inputs: Features_Event_When_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturday 10:00 · Strength Studio`)
};

const pl_features_event_when_one = /** @type {(inputs: Features_Event_When_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobota 10:00 · Studio Siła`)
};

/**
* | output |
* | --- |
* | "Saturday 10:00 · Strength Studio" |
*
* @param {Features_Event_When_OneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_event_when_one = /** @type {((inputs?: Features_Event_When_OneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Event_When_OneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_event_when_one(inputs)
	return en_features_event_when_one(inputs)
});